import React from 'react';
import {stylesheet} from 'typestyle';

import FFDropdownList, {FFDropdownListItem} from '../FFDropdownList';
import {KPI} from '../../kpi';
import {TProvider} from '../../i18n/i18n';
import {DataKey} from '../../stores/GeneralSelectorTableStore';
import {ChannelDiagramRequest} from '../../stores/GeneralLineDiagramStore';

interface KpiSwitcherProps {
    getChartableColumns: () => Array<{value: DataKey; text: string}>;
    diagrams: ChannelDiagramRequest[];
    changeKpiVariable: (changedKpi: KPI | 'mixed') => void;
}

export class KpiSwitcher extends React.Component<KpiSwitcherProps, {}> {
    public generateKpiOptions(selectedKpiField: KPI | '' | 'mixed', mixedAttributesVisibleText: string): FFDropdownListItem[] {
        const {getChartableColumns} = this.props;
        const options: FFDropdownListItem[] = getChartableColumns().map((item) => ({
            value: item.value,
            text: item.text,
        }));
        if (selectedKpiField === null) {
            console.warn('KpiSwitcher:generateKpiOptions:selectedKpiField is null?');
            options.unshift({value: '', text: ''});
        } else if (selectedKpiField === 'mixed') {
            options.unshift({value: 'mixed', text: mixedAttributesVisibleText});
        }
        return options;
    }

    public getSelectedKpiField(): KPI | '' | 'mixed' {
        const {diagrams} = this.props;

        const activeAttributes: KPI[] = [];
        diagrams.forEach((data) => {
            if (activeAttributes.indexOf(data.kpi) === -1) {
                activeAttributes.push(data.kpi);
            }
        });
        switch (activeAttributes.length) {
            case 0:
                return '';
            case 1:
                return activeAttributes[0];
            default:
                return 'mixed';
        }
    }

    public render() {
        return (
            <TProvider>
                {(t) => (
                    <FFDropdownList
                        className={kpiSwitcherCss.list}
                        listItems={this.generateKpiOptions(this.getSelectedKpiField(), t('chart:mixedAttributesVisibleText'))}
                        selectedValue={this.getSelectedKpiField()}
                        selectedValueChanged={this.props.changeKpiVariable}
                    />
                )}
            </TProvider>
        );
    }
}

const kpiSwitcherCss = stylesheet({
    list: {
        display: 'inline-block',
    },
});



// WEBPACK FOOTER //
// ./src/views/ExplorerParamsBar/KpiSwitcher.tsx